import Cookies from 'js-cookie';
import {BEARER_NAME} from '~/config/constants';

export const fetchAutocompleteData = async (url) => {
    const response = await fetch(url, {
        headers: {
            'Accept': 'application/json',
            ...Cookies.get(BEARER_NAME) && { 'Authorization': `Bearer ${Cookies.get(BEARER_NAME)}` }
        }
    });
    return await response.json();
};
